<template>
  <main>
    <div class="pra_all">
      <Tou></Tou>
      <div class="dad">
        <ul class="routing">
          <li>
            <span @click="Instructions_YI" class="Instructions">常见问题</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class="Instructions" @click="Instructions_ER">活动</span>
            <svg
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-chevron-right"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
              />
            </svg>
            <span class>长期活动</span>
            <!-- <div class="border_linear"></div> -->
          </li>
        </ul>
        <ul class="pra_content tong">
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>
                如何白嫖海星云?
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />新人注册、实名认证成功可获得2个赠点奖励，后续额外还会有不定期的活动可以白嫖。
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>
                邀新奖励
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <br />V0-V6：新人注册，填邀请码首次充值100元，双方可得25点海星赠点
              <br />V3-V6：新人注册，填邀请码首次充值400元，双方可得100点海星赠点
              <br />
              <br />
              同时一年内可获得新人充值金额最高10%的返现奖励，满100元可提现，具体返现规则请看官网--常见问题--账户常见问题--VIP权益/VIP返现说明
            </div>
          </li>
          <li class="PC_li">
            <div class="title">
              <div>
                <div>问题:</div>
                周卡、月卡详情
              </div>
            </div>
            <div class="answer">
              <div class="da">答案:</div>
              <!--              <br />Vip0~vip1可以购买售价为168元的月卡每月只能购买一次即买即开无法转让，以及售价为59元的周卡，周卡不可转让，月卡周卡均为闲时卡，使用时间为周一至周五凌晨2点至晚19点。-->
              <!--              <br />VIP2可以购买售价为128元的月卡每月只能购买一次即买即开无法转让，以及售价为59元的周卡，周卡不可转让，月卡周卡均为闲时卡，使用时间为周一至周五凌晨2点至晚19点。-->
              <!--              <br />VIP3~VIP4可以购买售价为80元的月卡每月只能购买一次即买即开无法转让，以及售价为59元的周卡，周卡不可转让，月卡周卡均为闲时卡，使用时间为周一至周五凌晨2点至晚19点。-->
              <!--              <br />注意： <br />1，周卡、月卡数量有限，售完即止。-->
              <!--              <br />2，如有时长卡生效时无法购买及使用其他时长卡-->
              <!--              <br />3，时长卡使用时间为非法定节假日周一至周五凌晨2点至晚19点（其他时段会正常扣海星点）-->
              <!--              <br />4，如果小伙伴想购买周卡或者月卡可以在手机客户端点击充值购买,也可以在官网充值界面扫码购买。-->

              <br />●周卡计时方式：在激活到账的7天内拥有95小时的自由使用时长，可使用的时间段为周一到周五0点到19点之间，其他时间段无法使用。（法定节假日均可使用）
              <br />●周卡售价：海星云周卡59元/张（V0及以上均可购买），购买后立即生效，一周有效期。
              <br />● 月卡计时方式：
              在激活到账的30天内拥有418小时的自由使用时长，可使用的时间段为周一到周五0点到19点之间，其他时间段无法使用。（法定节假日均可使用）
              <br />●
              月卡售价：海星云周卡168元/张（V0及以上均可购买），购买后立即生效，一月有效期。
              <br />
              ●
              每人每次仅限购买1张，如需再次购买，需前一张时长卡（周卡或月卡）使用完毕。
              <br />● 超出时长卡使用的时间部分，按海星点扣费，下机自动结算。
              <br />● 时长卡不可转赠。 <br />●
              时长卡仅限普通机型线路使用，其他线路按正常海星点扣费。 <br />●
              时长卡售出后概不退换，最终解释权归海星云电脑所有。
            </div>
          </li>
        </ul>
      </div>
    </div>
  </main>
</template>

<script>
import Tou from '@/components/Tou.vue'
export default {
  components: {Tou},
  data () {
    return {
    }
  },
  mounted () {},
  methods: {
    Instructions_YI () {
      this.$router.push('./faq')
    },
    Instructions_ER () {
      this.$router.push('./activity')
    }
  }
}
</script>

<style lang="scss" scoped>
html,
body {
  width: 100%;
  height: 100%;
}
.pra_all {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #100e2e;
}
.pra_content {
  width: 1070px;
  min-height: 300px;
  padding: 10px 20px 30px 20px;
  margin-top: 30px;
}
.current {
  color: #ffffff94;
}
.current:hover {
  color: #ffffff94 !important;
}
.dad {
  margin-top: 170px;
  background-color: #100e2e;
}
.title {
  font-size: 18.3px;
  color: #ffffff;
  width: 1070px;
  font-weight: 900;
}
.title div {
  // text-indent: 25px;
  display: inline-block;
}
.tong {
  margin: 15px auto 0;
  background-color: #0d0b26;
  padding-top: 30px;
}
.PC_li {
  padding: 5px 0 6px 0;
  margin-bottom: 25px;
}
.answer {
  // text-indent: 20px;
  font-size: 16px;
  // color: #ffffff9c;
  color: white;
  width: 100%;
  min-height: 100px !important;
  border-radius: 3px;
  margin-top: 15px;
  padding: 5px 30px;
  background-color: #252e45;
}
.answer div {
  display: inline-block;
}
.da {
  font-size: 16px;
  margin-bottom: 10px;
}
@media screen and (max-width: 1000px) {
  .tong {
    width: 100%;
  }
  .dad {
    margin-top: 100px;
    background-color: #100e2e;
  }
}
.routing {
  height: 20px;
  width: 1070px;
  margin-top: 70px;
  font-size: 12px;
  line-height: 20px;
  margin: 0 auto;
}
.routing li {
  display: inline;
  position: relative;
}
.Instructions:hover {
  color: white;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  .routing {
    width: 100%;
  }
}
.border_linear {
  width: 100% !important;
  height: 1px !important;
  position: absolute;
  left: 0;
  bottom: 0;
  background: linear-gradient(
    to right,
    rgba(190, 187, 187, 0.1) 0%,
    rgba(190, 187, 187, 0.2) 10%,
    rgba(190, 187, 187, 0.3) 20%,
    rgba(190, 187, 187, 0.4) 30%,
    rgba(190, 187, 187, 0.5) 40%,
    rgba(190, 187, 187, 0.8) 50%,
    rgba(190, 187, 187, 0.5) 60%,
    rgba(190, 187, 187, 0.4) 70%,
    rgba(190, 187, 187, 0.3) 80%,
    rgba(190, 187, 187, 0.2) 90%,
    rgba(190, 187, 187, 0.1) 100%
  );
}
@media screen and (min-width: 999px) and (max-width: 1199px) {
  .dad {
    margin-top: 200px;
  }
}
@media screen and (min-width: 768px) and (max-width: 998px) {
  .dad {
    margin-top: 180px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonProblem/acvit/long.vue